import {
  Schema,
  isArraySchema,
  isObjectSchema,
  isStringSchema
} from '../types';
import { evaluateSubschema } from './evaluateSchema';
import { FORMAT_SANITIZERS } from './validators';

/**
 * Remove values that does not have a definition in the schema.
 *
 * When collecting values in the form UI we might end up with redundant
 * values if the users change conditional values and continue in a new branch
 * after having started in another branch.
 *
 * Returns a _new_ structure containing the correct values
 *
 * This function differs from getSchemaValues in that it discards
 * additional properties in the value structure not defined in the schema.
 *
 * @param schema Schema
 * @param mixed value
 */
function removeRedundantValues(schema: Schema, value: any) {
  if (isObjectSchema(schema)) {
    const properties = schema.properties || {};
    return Object.keys(properties).reduce((result, property) => {
      result[property] = removeRedundantValues(
        properties[property],
        value[property]
      );
      return result;
    }, {} as any);
  }

  if (isArraySchema(schema)) {
    return (value || []).map((item: any) =>
      removeRedundantValues(
        evaluateSubschema(schema.items, item) as Schema,
        item
      )
    );
  }

  if (
    isStringSchema(schema) &&
    schema.format &&
    FORMAT_SANITIZERS[schema.format]
  ) {
    return FORMAT_SANITIZERS[schema.format]!(value);
  }

  return value;
}

export default removeRedundantValues;
